import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loadEnrolments } from './actions';
import { getChild } from '../reducer';
import List from './List';
import Grid from './Grid';
import ui from '../../common/services/ui';

class Payments extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		this.props.loadEnrolments(this.props.pagination);
	}

	handleListEvent(listPagination) {
		this.props.loadEnrolments(listPagination);
	}

	render() {
		const { data, pagination } = this.props;

		return <div>
			{ui.isMobileView ? <Grid data={data} onFetchData={this.handleListEvent} {...pagination} /> :
				<List data={data} onFetchData={this.handleListEvent} {...pagination} />}
		</div>;
	}
}

const mapStateToProps = state => {
	const { parent, entities: { enrolments, centers, terms, grades }, pagination } = state;

	const enrolmentsPagination = pagination.enrolments.all || { ids: [], pageNumber: 1, pageSize: 10 };

	const visiblePayments = enrolmentsPagination.ids.map(id => enrolments[id]);
	visiblePayments.forEach(payment => {
		if (payment) {
			payment.child = getChild(parent, payment.childId);

			if (payment.lesson) {
				payment.lesson.center = centers[payment.lesson.centerId];
				payment.lesson.term = terms[payment.lesson.termId];
				payment.lesson.grade = grades[payment.lesson.gradeId];
			}
		}
	});

	return {
		data: visiblePayments,
		pagination: enrolmentsPagination
	};
};

export default connect(mapStateToProps, {
	loadEnrolments
})(withTranslation()(Payments));